/* eslint-disable @typescript-eslint/no-explicit-any */
import { GATEWAY_URL } from '@/config';
import React, { useCallback, useState } from 'react';
import $i18n from 'panda-i18n';
import { LABEL_TEXT, VAS_SERVICE_API } from '@/const';
import styles from './index.module.scss';
import { vToLabel } from '@/utils';
import { Box, Form, NumberPicker, Input, Grid, Message, Field } from '@fpxfd/next';
import FpxUpload from '@/components/FpxUpload';
import { trackFileUploadSuccess, trackFileUploadError } from '@/utils/tracker';

const { Row, Col } = Grid;

interface Props {
  field: Field;
  callBack: Function;
  type?: string;
  typeList?: string[];
  operationSegment?: string;
  consignmentNo?: string;
}

const FillPartCom = ({ field, callBack, type, typeList, operationSegment, consignmentNo }: Props) => {
  const [fileList, setFileList] = useState<String[]>([]);
  // 上传文件成功
  const onFileUploadSuccess = (file: any) => {
    const _fileUrl = `${file?.response?.data}^${file?.name}`;
    const _fileList = [...fileList];
    _fileList.push(_fileUrl);
    setFileList(_fileList);
    callBack && callBack(_fileList);
    file?.response?.data && Message.success($i18n.get({ id: 'FileUploaded.four_px', dm: '文件上传成功！' }));

    // 日志上传埋点
    trackFileUploadSuccess(consignmentNo, file?.name, file?.response);
  };
  // 上传文件失败
  const onFileUploadError = (file: any) => {
    // 日志上传埋点
    trackFileUploadError(consignmentNo, file?.name, file?.response);

    return Message.error(file?.response?.msg);
  };
  // 移除文件
  const onFileRemove = (file: any) => {
    const url = file?.url || file?.downloadURL || file?.imgURL;
    const _fileList = [...fileList]?.filter((e) => !e?.includes(url));
    setFileList(_fileList);
    callBack && callBack(_fileList);
  };

  /**
   * 获取数量
   * 贴超重标签 Paste overweight label
      贴箱唛 Paste box mark
      贴托唛 Paste pallet mark
      贴面单 Paste waybill
      贴装箱单 Paste packing list
      贴欧规安全标签 Paste Europe label
      贴FBA商品标签 Paste FBA Product Label
   */
  const getHLCom = useCallback(() => {
    return typeList?.map((e) => {
      return (
        <Col span="8">
          <Form.Item
            label={`${vToLabel(LABEL_TEXT, e)}`}
            required
            requiredMessage={$i18n.get({ id: 'BT.Required.four_px', dm: '必填' })}
          >
            <NumberPicker step={1} min={0} max={99999} style={{ width: '100%' }} name={e} />
          </Form.Item>
        </Col>
      );
    });
  }, [typeList]);

  const onChange = (info) => {
    console.log('onChange : ', info);
  };

  return (
    <>
      <Form>
        <Form.Item label={$i18n.get({ id: 'ResultAttachment.four_px', dm: '结果附件' })}>
          <Box direction="row" align={'center'} className={styles.uploadVasFile}>
            <FpxUpload
              action={`${GATEWAY_URL}${VAS_SERVICE_API}/valueAddedTask/uploadValueAddedTaskAttach`}
              accept=".doc, .docx, .xls, .xlsx, .pdf, .rar, .zip, .png, .gif, .jpeg, .jpg"
              onSuccess={onFileUploadSuccess}
              onRemove={onFileRemove}
              onError={onFileUploadError}
            />
          </Box>
        </Form.Item>
      </Form>

      <Form field={field} fullWidth style={{ marginBottom: '16px' }}>
        <Row gutter={24} wrap>
          {/* （标签处理 && 出库增值段） || 核实 */}
          {((type === 'HL' && operationSegment === 'OB') || type === 'VVW') && getHLCom()}
          <Col span="8">
            <Form.Item
              label={$i18n.get({ id: 'WorkingHours.four_px', dm: '所用工时' })}
              required
              requiredMessage={$i18n.get({ id: 'BT.Required.four_px', dm: '必填' })}
            >
              <NumberPicker
                step={0.1}
                min={0}
                max={999.9}
                style={{ width: '100%' }}
                name="workingHour"
                defaultValue={0}
                innerAfter={<span style={{ marginRight: '6px' }}>H</span>}
              />
            </Form.Item>
          </Col>
          <Col span="8">
            <Form.Item label={$i18n.get({ id: 'WarehouseRemarks.four_px', dm: '仓库备注' })}>
              <Input name="warehouseRemark" trim />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FillPartCom;
